FansMdl
	.constant( 'API_URL', ( function() {

		return {
			PRINT: appConsts.apiUrl + '/print/hue',
			FILTER: appConsts.apiUrl + '/filter',
			FAN: appConsts.apiUrl + '/fan',
			HUE: appConsts.apiUrl + '/hue',
			PRODUCT: appConsts.apiUrl + '/product'
		}
	})())


	.constant( 'CATALOG_URL', { URL: appConsts.catalogUrl})
	.constant( 'SITE_URL', { URL: appConsts.site_url})